export const getInitials = (name: string) => {
  const words = name.split(' ');
  const firstInitial = words[0].charAt(0).toUpperCase();
  const lastInitial =
    words.length > 1 ? words[words.length - 1].charAt(0).toUpperCase() : '';
  return firstInitial + lastInitial;
};
